namespace $.$$ {

	export class $shm_projects_tasks extends $.$shm_projects_tasks {

		@ $mol_mem
		tasks_data( next?: readonly $shm_projects_task_record[] ) {
			if( next !== undefined ) return next
			return this.$.$shm_projects_tasks_list( this.project_id() )
		}

		tasks_filtered() {
			const filter = this.filter().trim().toLowerCase()
			const tasks = this.tasks_data().filter( task => !filter
				|| task.title.toLowerCase().includes( filter )
				|| task.description.toLowerCase().includes( filter )
			)
			const time = this.sort_by() === 'updated'
				? ( task: $shm_projects_task_record )=> task.updated_at ?? task.created_at
				: ( task: $shm_projects_task_record )=> task.created_at
			const direction = this.sort_order() === 'asc' ? 1 : -1
			return tasks.toSorted( ( left, right )=> direction * ( time( left ) - time( right ) ) )
		}

		task_rows() {
			const tasks = this.tasks_filtered()
			return tasks.length ? tasks.map( task => this.List().Task_link( task.id ) ) : [ this.Empty() ]
		}

		task_id( id: string ) {
			return id
		}

		task_selected() {
			const id = this.$.$mol_state_arg.value( 'project_task' ) ?? ''
			return this.tasks_data().some( task => task.id === id ) ? id : ''
		}

		task_arg( id: string ) {
			return {
				project_tab: 'tasks',
				project_task: id,
				goal_run: null,
				goal_iteration: null,
				project_thinking: null,
			}
		}

		task_title( id: string ) {
			return this.tasks_data().find( task => task.id === id )?.title ?? id
		}

		task_current( id: string ) {
			return this.task_selected() === id
		}

		@ $mol_action
		override task_add( next?: Event ) {
			if( next === undefined ) return null
			const task = ( this.$ as any ).$shm_projects_task_create( this.project_id() ) as $shm_projects_task_record
			this.tasks_data([ task, ... this.tasks_data() ])
			this.$.$mol_state_arg.value( 'project_task', task.id )
			return next
		}

		task_pages() {
			const selected = this.task_selected()
			return [
				this.List(),
				...( selected ? this.Task( selected ).pages_deep() : [] ),
			]
		}

	}

}
